import { Chain } from "thirdweb";
import { base, baseSepolia, ethereum, sepolia } from "thirdweb/chains";

export class Redirector {
    private static readonly GIT_BOOK_BASE_URL = "https://docs.cityversetycoon.com/";
    private static readonly CHAIN_TO_EXPLORER_URL = new Map<Chain, string>([
        [sepolia, "https://sepolia.etherscan.io/address/{0}"],
        [baseSepolia, "https://sepolia.basescan.org/address/{0}"],
        [base, "https://basescan.org/address/{0}"],
        [ethereum, "https://etherscan.io/address/{0}"]
    ]);
    private static readonly DEFAULT_CHAIN_EXPLORER_URL = "https://basescan.org/address/{0}";

    public static get redirectorUrl(): string {
        return `${location.origin}/redirector/`;
    }

    public static get intercomUrl(): string {
        return `${location.origin}/intercom/`;
    }

    public static openPageInNewTab(url: string): void {
        const redUrl = `${Redirector.redirectorUrl}?url=${url}`;
        window.open(redUrl, "_blank");
    }

    public static openIntercom(email: string, createdAt: number, name: string, userId: string): void {
        if (userId == null || userId.length === 0) {
            userId = localStorage.getItem("_CVT_GUEST_ID");
        }
        const params = new URLSearchParams(JSON.stringify({ email, createdAt, name, userId }));
        Redirector.openPageInNewTab(`${Redirector.intercomUrl}?data=${params}`);
    }

    public static openGitBook(page?: GitBookPage): void {
        Redirector.openPageInNewTab(page == null ? Redirector.GIT_BOOK_BASE_URL : `${Redirector.GIT_BOOK_BASE_URL}/${page}`);
    }

    public static openTransactionDetails(chain: Chain, smartWalletAddress: string): void {
        let explorerUrl = Redirector.DEFAULT_CHAIN_EXPLORER_URL;
        if (Redirector.CHAIN_TO_EXPLORER_URL.has(chain)) {
            explorerUrl = Redirector.CHAIN_TO_EXPLORER_URL.get(chain);
        }
        const url = explorerUrl.replace("{0}", smartWalletAddress);
        this.openPageInNewTab(url);
    }
}

export enum GitBookPage {
    COOKIE_POLICY = "important-information/ownplay-cookie-policy",
    PRIVACY_POLICY = "important-information/privacy-policy",
    TERMS_OF_USE = "important-information/terms-of-use",
    EXPORT_IN_GAME_ASSETS = "marketplace/wallets/how-to-export-in-game-assets",
    EXPORT_WALLET_PRIVATE_KEY = "marketplace/wallets/how-to-export-in-game-wallet-private-key",
    BUYING_AND_SELLING = "marketplace/buying-and-selling"
}